var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{class:['custom-btn', _vm.classes || ''],on:{"click":_vm.onclick}},[(_vm.submitting)?_c('b-spinner',{class:['mr-2', _vm.spinnerClass],style:({ width: _vm.spinnerWidth, height: _vm.spinnerHeight })}):_vm._e(),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }